import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'; // Importa Link
import CircleStatus from '../CircleStatus/CircleStatus'; // Importa el componente
import axios from 'axios';
import apiClient from '../../utils/apiClient';
import { clearDataCache } from '../../utils/cacheManager';
import './List.css'

import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CFormLabel,
  CFormInput,
  CFormSelect,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CModalContent,
  CTooltip,
  CPagination,
  CPaginationItem,
  CSpinner,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import {
  cilCursor,
  cilOptions,
  cilTrash,
  cilX,
  cilMagnifyingGlass,
  cilFolder,
  cilHistory,
  cilCheckCircle,
} from '@coreui/icons'

import circleRojo from '../../assets/images/circle-rojo.png';
import circleGris from '../../assets/images/circle-gris.png';
import reset from '../../assets/images/reset.png'
import stop from '../../assets/images/stop.png'
import init from '../../assets/images/init.png'
import play from '../../assets/images/play.png'
import editar from '../../assets/images/editar.png'
import trash from '../../assets/images/trash.png'
import check from '../../assets/images/check.png'
import ListSkeleton from './ListSkeleton';

const List = ({ profile, setProfile }) => {
  const [username, setUsername] = useState(localStorage.getItem('name') || profile || 'Usuario');

  useEffect(() => {
    if (profile) setUsername(profile);
  }, [profile]);
  // const [profile, setProfile] = useState(localStorage.getItem('name') || '');
  const navigate = useNavigate();
  const [nombreProyecto, setNombreProyecto] = useState('');
  const [periodo, setPeriodo] = useState(null);
  const [estado, setEstado] = useState(null);
  const [visible, setVisible] = useState(false)
  const [visible2, setVisible2] = useState(false)
  const [visibleEdit, setVisibleEdit] = useState(false)
  // const [scrollOffset, setScrollOffset] = useState(0);
  // const tableRef = useRef(null); // Referencia para la tabla
  const [isLoading, setIsLoading] = useState(true);
  const [fetchCompleted, setFetchCompleted] = useState(false);
  const [error, setError] = useState(null);
  // track the full list of projects retrieved from the API (not just in localStorage)
  const [allProjects, setAllProjects] = useState([]);
  const [itemId, setItemId] = useState(null); // Estado para almacenar el ID del elemento a eliminar
  const [itemId2, setItemId2] = useState(null);
  const [dataVideo, setDataVideo] = useState(null);
  const [statusSalad, setStatusSalad] = useState('none');
  const [idProject, setIdProject] = useState(null);
  const [nameProject, setNameProject] = useState('');
  const [mensajeSalad, setMensajeSalad] = useState('');
  const [mensajeSaladSuccess, setMensajeSaladSuccess] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [registro, setRegistro] = useState('');
  const [contenidoModal, setContenidoModal] = useState('');
  const [idModal, setIdModal] = useState(null);
  const [kmInicioEdit, setKmInicioEdit] = useState('');
  const [kmFinEdit, setKmFinEdit] = useState('');
  const [tipoCamaraEdit, setTipoCamaraEdit] = useState('');
  const [estatusEdit, setEstatusEdit] = useState('');
  const [idEstatusEdit, setIdEstatusEdit] = useState('');
  const [visibleSuccess, setVisibleSuccess] = useState('');
  const [showProcessToast, SetShowProcessToast] = useState('');
  const [videos, setVideos] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50); // Elige el número que prefieras
  const [totalPages, setTotalPages] = useState(1);
  const [currentItems, setCurrentItems] = useState([]);

  // Función para obtener datos del servidor
  function truncateText(text, maxLength, truncationText = "...") {
    if (text && text.length > maxLength) {
      return text.substring(0, maxLength) + truncationText;
    }
    return text;
  }

  async function fetchData(signal) {
    setIsLoading(true);
    setFetchCompleted(false);
    try {
      const response = await apiClient.get('/jwt/list/project', { signal });
      const jsonData = response.data;
      // guardamos en localStorage por compatibilidad antigua
      localStorage.setItem('data', JSON.stringify(jsonData));
      // normalizar la estructura y guardar en el estado local
      let normalized = [];
      if (Array.isArray(jsonData)) {
        normalized = jsonData;
      } else if (jsonData && Array.isArray(jsonData.data)) {
        normalized = jsonData.data;
      } else if (jsonData && Array.isArray(jsonData.projects)) {
        normalized = jsonData.projects;
      } else if (jsonData && typeof jsonData === 'object') {
        const numericKeys = Object.keys(jsonData).filter(k => String(Number(k)) === k);
        if (numericKeys.length > 0) {
          normalized = numericKeys
            .sort((a, b) => Number(a) - Number(b))
            .map(k => jsonData[k]);
        }
      }
      
      if (signal && signal.aborted) return;
      
      setAllProjects(normalized);
      setFetchCompleted(true);
    } catch (error) {
      if (axios.isCancel(error) || error.name === 'AbortError') {
        console.log('Fetch projects canceled');
      } else {
        setError(error);
        setIsLoading(false);
      }
    } finally {
      // setIsLoading(false); // Managed by processing effect
    }
  };

  // Llama a fetchData cuando el componente se monta
  useEffect(() => {
    const controller = new AbortController();
    fetchData(controller.signal);
    return () => controller.abort();
  }, []);

  useEffect(() => {
    // use the allProjects state rather than reading directly from localStorage
    let projects = allProjects;
    // Fallback if state is empty but localStorage has something (initial render before fetch completes)
    if (projects.length === 0) {
      const raw = localStorage.getItem('data');
      if (raw) {
        try {
          const parsed = JSON.parse(raw);
          if (Array.isArray(parsed)) {
            projects = parsed;
          } else if (parsed && Array.isArray(parsed.data)) {
            projects = parsed.data;
          } else if (parsed && Array.isArray(parsed.projects)) {
            projects = parsed.projects;
          } else if (parsed && typeof parsed === 'object') {
            const numericKeys = Object.keys(parsed).filter(k => String(Number(k)) === k);
            if (numericKeys.length > 0) {
              projects = numericKeys.sort((a, b) => Number(a) - Number(b)).map(k => parsed[k]);
            }
          }
        } catch (err) {
          console.warn('List: failed to parse localStorage.data', err);
          projects = [];
        }
      }
    }

    // filtro normal
    const filtered = projects.filter((item) => {
      const searchTerms = (nombreProyecto || '').toLowerCase();
      const nombreOk = !searchTerms ? true :
        (item.nombre || '').toLowerCase().includes(searchTerms) ||
        String(item.id).includes(searchTerms);
      const estadoOk = !estado || estado === null ? true : item.estado === estado;
      let periodoOk = true;
      if (periodo && !isNaN(periodo)) {
        const currentDate = new Date();
        const limitDate = new Date(currentDate.getTime() - periodo * 24 * 60 * 60 * 1000);
        const fechaInicio = item.fecha_inicio ? new Date(item.fecha_inicio) : null;
        periodoOk = fechaInicio ? fechaInicio >= limitDate : false;
      }
      return nombreOk && estadoOk && periodoOk;
    });

    const startIdx = (currentPage - 1) * itemsPerPage;
    const endIdx = startIdx + itemsPerPage;
    setCurrentItems(filtered.slice(startIdx, endIdx));
    setTotalPages(Math.max(1, Math.ceil(filtered.length / itemsPerPage)));

    // Si la API ya terminó y ya procesamos los items, quitamos los skeletons
    if (fetchCompleted && isLoading) {
         // Pequeño delay extra opcional para suavidad, pero el procesamiento ya terminó aquí
         setIsLoading(false);
    }

  }, [nombreProyecto, estado, periodo, currentPage, allProjects, isLoading, fetchCompleted]);

  const renderPagination = (totalPagesCount, currentPageNumber, onPageClick) => {
    const total = parseInt(totalPagesCount, 10) || 0;
    const current = parseInt(currentPageNumber, 10) || 1;
    if (total <= 1) return null;
    const items = [];

    // Prev (<<)
    items.push(
      <CPaginationItem key="prev" disabled={current === 1} onClick={() => onPageClick(Math.max(1, current - 1))}>
        {'<'}
      </CPaginationItem>
    );

    // First page + left ellipsis
    if (current > 2) {
      items.push(
        <CPaginationItem key={1} active={1 === current ? 'true' : undefined} onClick={() => onPageClick(1)}>
          {1}
        </CPaginationItem>
      );
      if (current > 3) {
        items.push(
          <CPaginationItem key="start-ellipsis" disabled>
            ...
          </CPaginationItem>
        );
      }
    }

    // Pages around current: current-1, current, current+1
    const start = Math.max(1, current - 1);
    const end = Math.min(total, current + 1);
    for (let p = start; p <= end; p++) {
      items.push(
        <CPaginationItem key={p} active={p === current ? 'true' : undefined} onClick={() => onPageClick(p)}>
          {p}
        </CPaginationItem>
      );
    }

    // Right ellipsis + last page
    if (current < total - 1) {
      if (current < total - 2) {
        items.push(
          <CPaginationItem key="end-ellipsis" disabled>
            ...
          </CPaginationItem>
        );
      }
      items.push(
        <CPaginationItem key={total} active={total === current ? 'true' : undefined} onClick={() => onPageClick(total)}>
          {total}
        </CPaginationItem>
      );
    }

    // Next (>>)
    items.push(
      <CPaginationItem key="next" disabled={current === total} onClick={() => onPageClick(Math.min(total, current + 1))}>
        {'>'}
      </CPaginationItem>
    );

    return (
      <CPagination aria-label="Page navigation example" className="cursor-pointer">
        {items}
      </CPagination>
    );
  };

  const handlePageClick = (pageNumber) => setCurrentPage(pageNumber);

  const deleteProject = async (id) => {
    try {
      const tokenData = localStorage.getItem('token');
      let token = tokenData;
      if (tokenData && (tokenData.startsWith('{') || tokenData.startsWith('['))) {
        try {
          const parsed = JSON.parse(tokenData);
          token = parsed.token || tokenData;
        } catch (e) {
          token = tokenData;
        }
      }
      const response = await apiClient.delete(`/api/delete/project/${id}`);
      
      if (response.status === 200) {
        console.log("Status 200: Borrado Correctamente");
        window.location.href = '/'; // Ajusta la ruta si es necesario 
      }
    } catch (error) {
      console.error('Error eliminando proyecto:', error);
    }
  };

  const handleResetFilters = () => {
    setNombreProyecto('');
    setEstado(null);
    setPeriodo(null);
    const estadoEl = document.getElementById("estadoProyecto");
    const periodoEl = document.getElementById("periodo");
    if (estadoEl) estadoEl.value = "";
    if (periodoEl) periodoEl.value = "";
    fetchData(); // También refrescamos los datos del servidor
  };

  const handleRowClick = (item, e) => {
    // Prevent navigation if clicking on dropdown toggle, menu, or any button
    if (e.target.closest('.dropdown') ||
      e.target.closest('.dropdown-menu') ||
      e.target.closest('.btn-dropdown-list') ||
      e.target.closest('button')) {
      return;
    }
    localStorage.setItem('lastProjectVisited', item.id);
    navigate(`/detail-project/${item.id}`);
  };
  const handleDelete = (id) => {
    setItemId(id); // Almacena el ID antes de abrir el modal
    setRegistro('Proyecto');
    setContenidoModal('Estas por eliminar el proyecto de manera definitiva, recuerda que una vez eliminado no podras recuperar esa información. ¿Estas seguro que deses eliminarlo?')
    setIdModal(1);
    setVisible(true);
  };

  const handleDeleteVideo = (id) => {
    setItemId(id); // Almacena el ID antes de abrir el modal
    setRegistro('Video');
    setContenidoModal('¿Estas seguro de eliminar el video?')
    setIdModal(2);
    setVisible2(false);
    setVisible(true);
  };

  const handleConfirmDelete = () => {
    // Llama a tu función de API con el itemId
    console.log('itemId1: ', itemId)
    if (idModal == 1) {
      deleteProject(itemId);
      setVisible(false);
    } else if (idModal == 2) {
      deleteFormVideo(itemId);
      setVisible(false);
      // handleProcess(idProject)
      // setVisible2(true);
    }

    // navigate('/');

  };

  const handleEditVideo = (id, index) => {
    setItemId2(id); // Almacena el ID antes de abrir el modal
    setRegistro('Video');
    setContenidoModal('¿Estas seguro de eliminar el video?')
    setIdModal(2);
    setVisible2(false);
    setVisible(false);
    setVisibleEdit(true);
    const dataVideo = JSON.parse(localStorage.getItem('data_video') || '[]'); // Parsear PRIMERO

    if (dataVideo && dataVideo.length > index) { // Verificar que el índice exista
      const item = dataVideo[index]; // Acceder al elemento por índice

      setKmInicioEdit(item.km_inicio);
      setKmFinEdit(item.km_fin);
      setTipoCamaraEdit(item.tipo_camara);
      setEstatusEdit(item.descripcion);
      setIdEstatusEdit(item.id_descripcion);


    } else {
      console.error("Índice fuera de rango o 'data_video' no encontrado en localStorage");
      // Manejar el error apropiadamente, por ejemplo, mostrando un mensaje al usuario.
    }


  };

  const handleConfirmDeleteVideo = () => {
    // Llama a tu función de API con el itemId
    console.log('itemId1: ', itemId)
    deleteFormVideo(itemId);
    // navigate('/');
    console.log('itemId: ', itemId)

    // Cierra el modal
    setVisible(false);
    setVisible2(true);
  };

  const handleProcess = async (id, nombre, index) => {
    if (index == 1) {
      setNameProject(nombre)
    }
    setIsLoading(true);
    try {
      // setNameProject(nombre)
      setIdProject(id)
      const tokenData = localStorage.getItem('token');
      let token = tokenData;
      if (tokenData && (tokenData.startsWith('{') || tokenData.startsWith('['))) {
        try {
          const parsed = JSON.parse(tokenData);
          token = parsed.token || tokenData;
        } catch (e) {
          token = tokenData;
        }
      }
      const response = await apiClient.get(`/api/video/get-data-video/${id}`);
      const jsonData = response.data;

      const dataVideo = Array.isArray(jsonData.data_video) ? jsonData.data_video : [];
      const dataStatus = Array.isArray(jsonData.data_status) ? jsonData.data_status : [];

      localStorage.setItem('data_video', JSON.stringify(dataVideo));

      setVideos(dataVideo); // Actualiza el estado con los nuevos datos
      setDataVideo(dataVideo); // Si `setDataVideo` es otro estado, lo actualiza también
      if (dataStatus.length > 0) {
        setStatusSalad(dataStatus[0].status)
      }

    } catch (error) {
      setError(error);
      console.error('Error al obtener datos:', error);
    } finally {
      setIsLoading(false);
    }

    setItemId(id);
    setVisible2(true);
    // handleReloadStatus()
  }


  const handleReloadStatus = async () => {
    setIsLoading(true);
    try {
      const tokenData = localStorage.getItem('token');
      let token = tokenData;
      if (tokenData && (tokenData.startsWith('{') || tokenData.startsWith('['))) {
        try {
          const parsed = JSON.parse(tokenData);
          token = parsed.token || tokenData;
        } catch (e) {
          token = tokenData;
        }
      }
      const response = await apiClient.get(`/api/video/get-data-video/${idProject}`);
      const jsonData = response.data;
      // localStorage.setItem('data', JSON.stringify(jsonData));
      const dataVideo = Array.isArray(jsonData.data_video) ? jsonData.data_video : [];
      const dataStatus = Array.isArray(jsonData.data_status) ? jsonData.data_status : [];

      setVideos(dataVideo); // Actualiza el estado con los nuevos datos
      setDataVideo(dataVideo); // Si `setDataVideo` es otro estado, lo actualiza también
      if (dataStatus.length > 0) {
        setStatusSalad(dataStatus[0].status)
      }

      console.log(jsonData.status);

    } catch (error) {
      setError(error);
      console.error('Error al obtener datos:', error);
    } finally {
      setMensajeSaladSuccess('')
      setMensajeSalad('');
      setIsLoading(false);
    }
    // setItemId(id); // Almacena el ID antes de abrir el modal
    // setVisible2(true);
  }

  const handleStartSalad = async () => {
    setIsLoading(true);
    try {
      const tokenData = localStorage.getItem('token');
      let token = tokenData;
      if (tokenData && (tokenData.startsWith('{') || tokenData.startsWith('['))) {
        try {
          const parsed = JSON.parse(tokenData);
          token = parsed.token || tokenData;
        } catch (e) {
          token = tokenData;
        }
      }
      const response = await apiClient.get(`/api-start-videos-process`);
      const jsonData = response.data;
      // localStorage.setItem('data', JSON.stringify(jsonData));
      // setStatusSalad(jsonData.status)
      // console.error(statusSalad.status);

    } catch (error) {
      setError(error);
      console.error('Error al obtener datos:', error);
    } finally {
      setMensajeSaladSuccess('')
      setMensajeSalad('');
      handleReloadStatus()
      setIsLoading(false);
    }
    // setItemId(id); // Almacena el ID antes de abrir el modal
    // setVisible2(true);
  }

  const handleStopSalad = async () => {
    setIsLoading(true);
    try {
      const tokenData = localStorage.getItem('token');
      let token = tokenData;
      if (tokenData && (tokenData.startsWith('{') || tokenData.startsWith('['))) {
        try {
          const parsed = JSON.parse(tokenData);
          token = parsed.token || tokenData;
        } catch (e) {
          token = tokenData;
        }
      }
      const response = await apiClient.get(`/api-stop-videos-process`);
      const jsonData = response.data;
      // localStorage.setItem('data', JSON.stringify(jsonData));
      // setStatusSalad(jsonData.status)
      // console.error(statusSalad.status);

    } catch (error) {
      setError(error);
      console.error('Error al obtener datos:', error);
    } finally {
      setMensajeSaladSuccess('')
      setMensajeSalad('');
      handleReloadStatus()
      setIsLoading(false);
    }
    // setItemId(id); // Almacena el ID antes de abrir el modal
    // setVisible2(true);
  }

  const handleSendSalad = async () => {
    setIsLoading(true);
    setMensajeSaladSuccess('')
    setMensajeSalad('');
    setMensaje('Espere...')
    try {
      const response = await apiClient.get(`/api-send-videos-process/${idProject}`);
      
      if (response.status === 200) {
        setMensaje('');
        setMensajeSalad('');
        setMensajeSaladSuccess(('Exito. 200 Procesando...'));
      }
      
      const jsonData = response.data;
      // localStorage.setItem('data', JSON.stringify(jsonData));
      // setStatusSalad(jsonData.status)
      // console.error(statusSalad.status);
    } catch (error) {
      setError(error);
      console.error('Error al obtener datos:', error);
    } finally {
      setIsLoading(false);
      setMensaje('')
    }
  }

  const deleteFormVideo = async (id) => {
    setIsLoading(true);
    try {
      const response = await apiClient.delete(`/api/video/delete-data-video/${id}`);
      
      if (response.status === 200) {
        // console.log("Status 200: Borrado Correctamente");
      }
    } catch (error) {
      setError(error);
      console.error('Error al eliminar video:', error);
    } finally {
      setIsLoading(false);
      setVisibleSuccess(true);
    }
  }

  const handleUpdateVideo = async () => {
    const id = itemId2;
    const formData = new FormData();
    formData.append('kmInicioEdit', kmInicioEdit);
    formData.append('kmFinEdit', kmFinEdit);
    formData.append('tipoCamaraEdit', tipoCamaraEdit);
    formData.append('idEstatusEdit', idEstatusEdit);

    try {
      const response = await apiClient.post(`/api/video/edit-data-video/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      });
    } catch (error) {
       console.error('Error al actualizar video:', error);
    } finally {
      setIsLoading(false);
      setVisibleEdit(false);
      setVisibleSuccess(true);
    }
  };

  function backlist() {
    setVisibleSuccess(false)
    handleProcess(idProject, nombreProyecto, 2)
  }

  function backhome() {
    window.location.href = '/';
  }

  return (
    <div className="dashboard-container">
      {/* Welcome Banner */}
      <div className="welcome-banner-compact mb-4 shadow-sm">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h2 className="welcome-title-compact text-white mb-1">¡Hola, {username}!</h2>
            <p className="welcome-subtitle-compact text-white opacity-75 mb-0">
              Panel de gestión vial inteligente.
            </p>
          </div>
          <CButton
            href="/new-project/form"
            className="btn-new-project-compact shadow-sm"
          >
            Nuevo Proyecto
          </CButton>
        </div>
      </div>



      <CRow className='g-4'>
        <CCol xs={12}>
          {/* Action Bar (Filters) */}
          <CCard className="action-bar-modern p-2 mb-4">
            <CRow className='align-items-center g-2'>
              <CCol md={5}>
                <div className="position-relative">
                  <CIcon
                    icon={cilMagnifyingGlass}
                    className="position-absolute top-50 translate-middle-y ms-3 text-muted"
                    style={{ zIndex: 10, pointerEvents: 'none', width: '18px', opacity: 0.5 }}
                  />
                  <CFormInput
                    className="modern-input-compact w-100"
                    style={{ paddingLeft: '3.5rem' }}
                    placeholder="          Buscar por nombre o ID de proyecto..."
                    value={nombreProyecto || ''}
                    onChange={(e) => setNombreProyecto(e.target.value)}
                  />
                </div>


              </CCol>

              <CCol md={3}>
                <CFormSelect
                  className='modern-select-compact'
                  value={estado || ''}
                  onChange={(e) => setEstado(e.target.value)}>
                  <option value="">Todos los estados</option>
                  <option value="creado">Creado</option>
                  <option value="procesando">Procesando</option>
                  <option value="finalizado">Finalizado</option>
                </CFormSelect>
              </CCol>

              <CCol md={3}>
                <CFormSelect
                  className='modern-select-compact'
                  value={periodo || ''}
                  onChange={(e) => setPeriodo(e.target.value)}>
                  <option value="">Cualquier periodo</option>
                  <option value="7">Últimos 7 dias</option>
                  <option value="15">Últimos 15 dias</option>
                  <option value="30">Últimos 30 dias</option>
                </CFormSelect>
              </CCol>

              <CCol md={1} className="text-end">
                <CTooltip content="Limpiar filtros">
                  <CButton
                    className="btn-reset-compact"
                    onClick={handleResetFilters}
                  >
                    <CIcon icon={cilX} />
                  </CButton>
                </CTooltip>
              </CCol>
            </CRow>
          </CCard>

          {/* Table Container */}
          <CCard className="table-container-modern border-0 bg-transparent mb-4">
            <CCardBody className='p-0'>
              <div className='contenedor-scroll-tabla-list' style={{ overflowY: 'auto', maxHeight: '550px', position: 'relative' }}>
                {isLoading && currentItems.length === 0 ? (
                  <ListSkeleton />
                ) : (
                  <>
                    {isLoading && (
                      <div className="loading-overlay" style={{ background: 'rgba(255,255,255,0.3)', borderRadius: '16px', zIndex: 100, position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <CSpinner color="primary" />
                      </div>
                    )}
                    <CTable align="middle" className="mb-0 modern-table">
                      <CTableHead className='sticky-header'>
                        <CTableRow>
                          <CTableHeaderCell className='text-center'>ID</CTableHeaderCell>
                          <CTableHeaderCell>Proyecto</CTableHeaderCell>
                          <CTableHeaderCell>Creación</CTableHeaderCell>
                          <CTableHeaderCell>Estado</CTableHeaderCell>
                          <CTableHeaderCell>Periodo</CTableHeaderCell>
                          <CTableHeaderCell className="text-center">Cant.</CTableHeaderCell>
                          <CTableHeaderCell></CTableHeaderCell>
                        </CTableRow>
                      </CTableHead>
                      <CTableBody>
                        {currentItems && currentItems.length > 0 && currentItems.map((item, index) => (
                          <CTableRow key={index} className="stagger-in clickable-row" style={{ animationDelay: `${index * 40}ms` }} onClick={(e) => handleRowClick(item, e)}>
                            <CTableDataCell className="text-center fw-bold text-muted" style={{ fontSize: '0.8rem' }}>
                              #{item.id}
                            </CTableDataCell>
                            <CTableDataCell className='fw-semibold'>
                              <div className="d-flex align-items-center">
                                <img
                                  src={item.video_procesar === 1 ? circleRojo : circleGris}
                                  alt="Status"
                                  className="me-2"
                                  style={{ width: '8px', height: '8px' }}
                                />
                                {truncateText(item.nombre || 'Sin nombre', 30)}
                              </div>
                            </CTableDataCell>
                            <CTableDataCell className="small text-muted">
                              {item.fecha_creacion}
                            </CTableDataCell>
                            <CTableDataCell>
                              <span className={`badge-status badge-${(item.estado || '').toLowerCase()}`}>
                                {item.estado}
                              </span>
                            </CTableDataCell>
                            <CTableDataCell>
                              <div className="small fw-medium">
                                {item.fecha_inicio || '-'}
                              </div>
                              <div className="small text-muted" style={{ fontSize: '0.7rem' }}>
                                al {item.fecha_fin || '-'}
                              </div>
                            </CTableDataCell>
                            <CTableDataCell className="text-center">
                              <span className="fw-bold" style={{ color: '#3c4b64' }}>
                                {item.cantidad_detecciones || 0}
                              </span>
                            </CTableDataCell>
                            <CTableDataCell>
                              <CDropdown variant="btn-group">
                                <CDropdownToggle className='btn-dropdown-list border shadow-sm' color="light" size="sm">
                                  <CIcon icon={cilOptions} size="sm" />
                                </CDropdownToggle>
                                <CDropdownMenu className='shadow-lg border-0' style={{ borderRadius: '12px' }}>
                                  <CDropdownItem href={`/detail-project/${item.id}`} className="py-2">Ver detalle</CDropdownItem>
                                  <CDropdownItem className="cursor-pointer py-2" onClick={() => handleProcess(item.id, item.nombre, 1)}>Procesar</CDropdownItem>
                                  <CDropdownItem href={`/project/form-edit/${item.id}`} className="py-2">Editar</CDropdownItem>
                                  <CDropdownItem className="cursor-pointer py-2 text-danger" onClick={() => handleDelete(item.id)}>Eliminar</CDropdownItem>
                                </CDropdownMenu>
                              </CDropdown>
                            </CTableDataCell>
                          </CTableRow>
                        ))}
                      </CTableBody>
                    </CTable>
                  </>
                )}

              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      {currentItems.length > 0 && (
        <div className='center d-flex justify-content-center mt-3 pb-4'>
          {renderPagination(totalPages, currentPage, handlePageClick)}
        </div>
      )}

      {/* Modals */}
      <CModal
        alignment="center"
        visible={visible}
        onClose={() => setVisible(false)}
        size='sm'
      >
        <CModalContent style={{ borderRadius: '16px', overflow: 'hidden' }}>
          <CModalHeader closeButton className="border-0">
            <CModalTitle className='fw-bold'>Eliminar {registro}</CModalTitle>
          </CModalHeader>
          <CModalBody className='text-muted'>
            {contenidoModal}
          </CModalBody>
          <CModalFooter className="border-0">
            <CButton color="light" className="rounded-pill px-4" onClick={() => setVisible(false)}>
              Cancelar
            </CButton>
            <CButton color="danger" className="rounded-pill px-4 text-white" onClick={handleConfirmDelete}>Confirmar</CButton>
          </CModalFooter>
        </CModalContent>
      </CModal>

      <CModal
        alignment="center"
        visible={visibleSuccess}
        onClose={() => setVisibleSuccess(false)}
        size='sm'
      >
        <CModalContent style={{ borderRadius: '16px', overflow: 'hidden' }}>
          <CModalBody className='p-5 text-center'>
            <img src={check} alt="exitoso" style={{ width: '48px', height: '48px', marginBottom: '1.5rem' }} />
            <h4 className="fw-bold mb-3">¡Excelente!</h4>
            <p className="text-muted">La operación se realizó con éxito.</p>
          </CModalBody>
          <CModalFooter className="border-0 justify-content-center pb-4">
            <CButton color="dark" className="rounded-pill px-4" onClick={backlist}>Volver</CButton>
            <CButton color="light" className="rounded-pill px-4 border" onClick={backhome}>Salir</CButton>
          </CModalFooter>
        </CModalContent>
      </CModal>

      <CModal
        alignment="center"
        scrollable
        visible={visible2}
        onClose={() => setVisible2(false)}
        size='lg'
      >
        <CModalContent style={{ borderRadius: '20px', overflow: 'hidden' }}>
          <CModalHeader closeButton className="border-0">
            <CModalTitle className='fw-bold'>Proyecto Nro {idProject}. {nameProject}</CModalTitle>
          </CModalHeader>
          <CModalBody className="px-4">
            <div className="d-flex align-items-center mb-4 p-3 bg-light rounded-3">
              <div className="flex-grow-1">
                <span className='fw-bold me-2 small'>Estatus:</span>
                <CircleStatus statusSalad={statusSalad} />
                <CButton onClick={handleReloadStatus} variant="ghost" className="ms-3 p-1">
                  <img src={reset} alt="Reload" style={{ width: '20px' }} />
                </CButton>
              </div>
              <div className="text-end small">
                <div className="text-secondary">{mensaje}</div>
                <div className="text-success fw-bold">{mensajeSaladSuccess}</div>
                <div className="text-danger fw-bold">{mensajeSalad}</div>
              </div>
            </div>

            <div className="d-flex gap-2 mb-4 justify-content-center">
              <CTooltip content="Detener la IA" placement="top">
                <CButton disabled variant="outline" color="danger" onClick={handleStopSalad} className="rounded-circle p-2">
                  <img src={stop} alt="Stop" style={{ width: '24px' }} />
                </CButton>
              </CTooltip>
              <CTooltip content="Iniciar la IA" placement="top">
                <CButton disabled variant="outline" color="success" onClick={handleStartSalad} className="rounded-circle p-2">
                  <img src={init} alt="Init" style={{ width: '24px' }} />
                </CButton>
              </CTooltip>
              <CTooltip content="Procesar" placement="top">
                <CButton disabled variant="outline" color="primary" onClick={handleSendSalad} className="rounded-circle p-2">
                  <img src={play} alt="Play" style={{ width: '24px' }} />
                </CButton>
              </CTooltip>
            </div>

            <CTable align="middle" borderless hover className="modern-table-modal">
              <CTableHead className='bg-light'>
                <CTableRow>
                  <CTableHeaderCell className="small text-uppercase">Id</CTableHeaderCell>
                  <CTableHeaderCell className="small text-uppercase">Nombre archivo</CTableHeaderCell>
                  <CTableHeaderCell className="small text-uppercase">Cámara</CTableHeaderCell>
                  <CTableHeaderCell className="small text-uppercase">Status</CTableHeaderCell>
                  <CTableHeaderCell></CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {videos.map((item, index) => (
                  <CTableRow key={index} className="border-bottom">
                    <CTableHeaderCell className="text-muted">{item.id}</CTableHeaderCell>
                    <CTableDataCell className="fw-medium small">
                      {truncateText(item.nombre_archivo, 50)}
                    </CTableDataCell>
                    <CTableDataCell className="small">{item.tipo_camara}</CTableDataCell>
                    <CTableDataCell className="small">
                      <span className="badge bg-light text-dark border p-1" style={{ fontSize: '0.7rem' }}>{item.descripcion}</span>
                    </CTableDataCell>
                    <CTableDataCell className="text-end">
                      <CButton variant="ghost" color="light" size="sm" onClick={() => handleEditVideo(item.id, index)}>
                        <img src={editar} alt="Edit" style={{ width: '14px' }} />
                      </CButton>
                      <CButton variant="ghost" color="light" size="sm" className="ms-1" onClick={() => handleDeleteVideo(item.id)}>
                        <img src={trash} alt="Delete" style={{ width: '14px' }} />
                      </CButton>
                    </CTableDataCell>
                  </CTableRow>
                ))}
              </CTableBody>
            </CTable>
          </CModalBody>
          <CModalFooter className="border-0" />
        </CModalContent>
      </CModal>

      <CModal
        alignment="center"
        visible={visibleEdit}
        onClose={() => setVisibleEdit(false)}
      >
        <CModalContent style={{ borderRadius: '20px', overflow: 'hidden' }}>
          <CModalHeader closeButton className="border-0">
            <CModalTitle className='fw-bold'>Editar Formulario</CModalTitle>
          </CModalHeader>
          <CModalBody className="px-4">
            <CRow className="g-3 mb-3">
              <CCol md={6}>
                <CFormLabel className="small fw-bold text-muted">Km Inicio</CFormLabel>
                <CFormInput className='modern-input' value={kmInicioEdit} onChange={(e) => setKmInicioEdit(e.target.value)} />
              </CCol>
              <CCol md={6}>
                <CFormLabel className="small fw-bold text-muted">Km Fin</CFormLabel>
                <CFormInput className='modern-input' value={kmFinEdit} onChange={(e) => setKmFinEdit(e.target.value)} />
              </CCol>
            </CRow>
            <CRow className="g-3 mb-3">
              <CCol md={6}>
                <CFormSelect className='modern-select' label="Tipo Cámara" value={tipoCamaraEdit} onChange={(e) => setTipoCamaraEdit(e.target.value)}>
                  <option value="">Seleccionar...</option>
                  <option value="frontal1">Frontal-1</option>
                  <option value="frontal2">Frontal-2</option>
                  <option value="cenital1">Cenital-1</option>
                  <option value="cenital2">Cenital-2</option>
                </CFormSelect>
              </CCol>
            </CRow>
            <div className="mb-3">
              <CFormSelect className='modern-select' label="Estatus" value={idEstatusEdit} onChange={(e) => setIdEstatusEdit(e.target.value)}>
                <option value="">Seleccionar...</option>
                <option value="0">Pendiente</option>
                <option value="1">Descargando</option>
                <option value="2">En cola</option>
                <option value="3">Extracción de metadatos</option>
                <option value="4">Procesando</option>
                <option value="5">Actualizando base de datos</option>
                <option value="6">Actualizando frames</option>
                <option value="7">Completado</option>
                <option value="8">Error descargando</option>
                <option value="9">Error de procesamiento</option>
                <option value="10">Error subiendo frames</option>
                <option value="11">Sin Coordenadas GPS</option>
              </CFormSelect>
            </div>
          </CModalBody>
          <CModalFooter className="border-0 pb-4 px-4">
            <CButton color="light" className="rounded-pill px-4" onClick={() => setVisibleEdit(false)}>Cancelar</CButton>
            <CButton color="dark" className="rounded-pill px-4" onClick={handleUpdateVideo}>Guardar cambios</CButton>
          </CModalFooter>
        </CModalContent>
      </CModal>
    </div>
  )
}

export default List
